import { getToken } from "../../../shared/utils/common";

export class CommandSetTemplateThumbnail {
  async run(templateId: number, file: File) {
    const url = `${import.meta.env.VITE_API_PLATFORM_SERVICE_URL}api/v1/content/ad_templates/${templateId}/thumbnail/`;

    const formData = new FormData();
    formData.append("thumbnail_file", file);

    try {
      const response = await fetch(url, {
        method: "POST",
        headers: {
          "Authorization": `Token ${getToken()}`,
        },
        body: formData,
      });

      if (!response.ok) {
        throw new Error(`Upload failed: ${response.status} ${response.statusText}`);
      }

      return await response.json();
    } catch (err) {
      console.error("Error uploading thumbnail:", err);
      throw err;
    }
  }
}
